var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InformationToggle } from '@/components/information-toggle.component';
import { Troubleshooting } from '@/components/troubleshooting.component';
import { useStyledModal } from '@/hooks/use-styled-modal.hook';
import { palette } from '@/theme/palette';
import { ButtonBase, Typography } from '@mui/material';
export function SoundNotPlaying() {
    var _a = useStyledModal(_jsx(Troubleshooting, {})), modal = _a[0], toggleModal = _a[1];
    function soundNotPlayingClicked() {
        toggleModal();
    }
    return (_jsxs("div", __assign({ className: 'flex flex-col items-center md:gap-20 gap-10' }, { children: [_jsx(ButtonBase, __assign({ className: "w-fit", onClick: soundNotPlayingClicked }, { children: _jsx(Typography, __assign({ className: "text-lg cursor-pointer text-black underline" }, { children: "Sound not playing?" })) })), _jsx(InformationToggle, __assign({ title: "What is a comfortable listening level?", titleClass: 'text-norc-orange-dark md:text-2xl', chevronColor: palette.primary.main }, { children: _jsx(Typography, __assign({ className: "text-sm font-light leading-none md:text-lg md:font-medium max-w-72 md:max-w-[42.5rem]" }, { children: "Please find a comfortable listening level somewhere near the middle of your volume range. You should be able to clearly hear words being spoken. Select a listening level somewhere in the middle of your volume range. Volumes that are too loud or too quiet will risk the accuracy of the test." })) })), modal] })));
}
